<template>
  <el-dialog
    class="taskDialog"
    :title="thisDialosTitle"
    :visible.sync="isThisDialogVisible"
    width="90%"
    :before-close="handleThisDialogClose"
    @open="onTaskDialogOpen"
  >
    <!-- Solo el supervisor o CEO puede crear tareas -->
    <el-row class="movingColToEnd" v-if="canCreateTask">
      <el-col class="movingToLeft" :offset="3" :span="2">
        <el-button
          type="success"
          icon="el-icon-plus"
          size="small"
          @click="openTaskFormDialog"
          >Crear Tarea</el-button
        >
      </el-col>
    </el-row>
    <el-row class="reportContent">
      <rabbey-table-3
        :border="true"
        :stripe="true"
        :actions="tasksActions"
        @rtable-push-action="handlePushAction"
        :loading="loadingData"
        :data="tasksData"
        :columns="tasksColumns"
        show-summary
        sum-text="Tiempo Total"
      />
    </el-row>
    <TaskFormDialog
      :key="1"
      :TaskFormVisible="makeTaskFormVisible"
      :ObjectiveRow="thisActualObjective"
      :TaskRow="TaskRowToEdit"
      :ViewTask="ViewTask"
      :NegotiationId="thisNegotiationId"
      :ProspectId="thisPropectId"
      :CustomerCode="thisCustomerCode"
      :WhatsThisFormFor="WhatsTheFormFor"
      @ClosingTaskFormDialog="OnTaskFormDialogClose"
      @TaskSaved="OnTaskSaved"
    />
    <EvidenceDialog
      :isItVisible="isEvidenceDialogVisible"
      :RequestTaskId="RequestTaskId"
      :RTID="RequestTaskOriginalId"
      @updateReport="onUpdateReport"
      @DialogCloses="onEvidenceClose"
    />
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleThisDialogClose">Cerrar</el-button>
      <!-- <el-button type="primary" @click="handleThisDialogClose">Guardar</el-button> -->
    </span>
  </el-dialog>
</template>

<script>
import {
  TaskColumns,
  TaskActions
} from "@/columns/ObjectivesReport/ObjectivesDetailsTasksColumns";
import TaskFormDialog from "@/components/cmi/ObjectivesReport/TaskFormDialog";
import EvidenceDialog from "@/components/internal_requests/KPI/TasksReport/EvidenceDialog";

export default {
  name: "ObjectiveTasksDialog",
  components: {
    TaskFormDialog,
    EvidenceDialog
  },
  props: {
    ObjectiveTasksDialogVisibility: {
      type: Boolean,
      default: false,
      required: true
    },
    ActualObjective: {
      type: Object,
      default: () => {},
      required: true
    },
    columnTaskCodeFrom: {
      type: String,
      default: "",
      required: false
    },
    IsInCharged: {
      type: Boolean,
      default: false,
      required: false
    },
    NegotiationId: {
      type: Number,
      default: 0,
      required: false
    },
    PropectId: {
      type: Number,
      default: 0,
      required: false
    },
    CustomerCode: {
      type: String,
      default: "",
      required: false
    },
    TaskResponsibleSelected: {
      type: Number,
      default: 0,
      required: false
    },
    IsPendingFilter: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  data() {
    return {
      loadingData: false,
      tasksColumns: TaskColumns,
      tasksActions: TaskActions(this),
      tasksData: [],
      makeTaskFormVisible: false,
      TaskRowToEdit: {},
      WhatsTheFormFor: 0,
      isEvidenceDialogVisible: false,
      RequestTaskId: "",
      RequestTaskOriginalId: 0,
      ViewTask: false
    };
  },
  computed: {
    isThisDialogVisible() {
      return this.ObjectiveTasksDialogVisibility;
    },
    canCreateTask() {
      return (
        this.IsInRoles([this.roles.CEO]) ||
        Boolean(this.currentUser?.IsSupervisor)
      );
    },
    thisDialosTitle() {
      return (
        this.ActualObjective.ObjectiveCombinedId +
        " - " +
        this.ActualObjective.ObjectiveShortDescription
      );
    },
    thisActualObjective() {
      return this.ActualObjective;
    },
    thisNegotiationId() {
      return this.NegotiationId;
    },
    thisPropectId() {
      return this.PropectId;
    },
    thisCustomerCode() {
      return this.CustomerCode;
    }
  },
  methods: {
    handleThisDialogClose() {
      this.$emit("ObjectiveTasksDialogClosing", false);
    },
    onTaskDialogOpen() {
      this.GetTaskDataByObjectiveId(this.ActualObjective.ObjectiveId);
    },
    async GetTaskDataByObjectiveId(objectiveId) {
      this.loadingData = true;
      /*
          Codigos para diferencias los detalles de tareas segun la columna (@TaskCode)
            * TT - Total de Tareas
            * TR - Tareas Realizadas
            * TRTR - Tareas Retrasadas
            * TCSAnt - Tareas Cerradas Semana Anterior
            * TCSAct - Tareas Cerradas Semana Actual
            * TP - Tareas pendientes en progreso
            * TSA - Tareas Semana Actual
            * TSP - Tareas senmana proxima
      */

      await this.$http
        .get("/api/CMI/Objetives/GetTasksDetailsObjectivesReport", {
          params: {
            TaskCode: this.columnTaskCodeFrom,
            ObjectiveId: objectiveId,
            NegotiationId: this.thisNegotiationId,
            ProspectId: this.thisPropectId,
            CustomerCode: this.thisCustomerCode,
            ResponsibleTask: this.TaskResponsibleSelected,
            IsPendingFilter: this.IsPendingFilter
          }
        })
        .then(({ data }) => {
          //await this.KnowIfIsHisSupervisor(data.CreatedBy)
          this.tasksData = data;
          this.loadingData = false;
        });
    },
    openTaskFormDialog() {
      // WhatsTheFormFor 0 create, 1 editar
      this.ViewTask = false;
      this.WhatsTheFormFor = 0;
      this.TaskRowToEdit = {};
      this.makeTaskFormVisible = true;
    },
    OnTaskFormDialogClose() {
      this.makeTaskFormVisible = false;
    },
    OnTaskSaved() {
      this.makeTaskFormVisible = false;
      this.GetTaskDataByObjectiveId(this.ActualObjective.ObjectiveId);
      this.$emit("TaskSavedToObjective");
    },
    handlePushAction(option) {
      const { row } = option;
      switch (option.command) {
        case "view_task":
          {
            this.WhatsTheFormFor = 1;
            this.ViewTask = true;
            this.TaskRowToEdit = { ...row };
            this.makeTaskFormVisible = true;
          }
          break;
        case "edit_task": {
          if (
            row.ResponsableId !== this.currentUser.EmployeeId ||
            this.currentUser.EmployeeId === 37
          ) {
            if (this.IsInCharged) {
              // WhatsTheFormFor 0 create, 1 editar
              this.WhatsTheFormFor = 1;
              this.ViewTask = false;
              this.TaskRowToEdit = { ...row };
              this.makeTaskFormVisible = true;
            } else {
              this.$message({
                type: "error",
                message:
                  "No es encargado o gerente, por lo que no puede realizar esta acción"
              });
            }
            // WhatsTheFormFor 3 para edicion de objetivos
          } else {
            this.$message({
              type: "error",
              message:
                "Es el responsable de esta tarea, por lo que no puede realizar esta acción"
            });
          }
          break;
        }
        case "close_task": {
          this.RequestTaskId = row.CombinedTaskId;
          this.RequestTaskOriginalId = row.IdTask;
          this.isEvidenceDialogVisible = true;
          break;
        }
        case "delete_task": {
          if (
            row.ResponsableId !== this.currentUser.EmployeeId ||
            this.currentUser.EmployeeId === 37
          ) {
            if (this.IsInCharged) {
              this.$confirm(
                "Seguro que desea continuar con el borado de esta tarea?",
                row.CombinedTaskId,
                {
                  confirmButtonText: "Si",
                  cancelButtonText: "No",
                  type: "warning"
                }
              )
                .then(() => {
                  this.DeleteTaskGant(row.CombinedTaskId);
                })
                .catch(() => {
                  this.$message({
                    type: "info",
                    message: "Operacion Cancelada"
                  });
                });
            } else {
              this.$message({
                type: "error",
                message:
                  "No es encargado o gerente, por lo que no puede realizar esta acción"
              });
            }
          } else {
            this.$message({
              type: "error",
              message:
                "Usted es el responsable de esta tarea, por lo que no puede realizar esta acción"
            });
          }
          break;
        }
      }
    },
    DeleteTaskGant(TaskCombinedId) {
      this.$http
        .delete("/api/CMI/Task/DeleteGanttTask", {
          params: {
            TaskID: TaskCombinedId
          }
        })
        .then(() => {
          this.$message({
            type: "success",
            message: "Tarea borrada exitosamente"
          });
          this.GetTaskDataByObjectiveId(this.ActualObjective.ObjectiveId);
          this.$emit("TaskSavedToObjective");
        })
        .catch((err) => {
          this.$message({
            type: "error",
            message: ("Error al eliminar la tarea: ", err)
          });
        });
    },
    onUpdateReport() {
      this.GetTaskDataByObjectiveId(this.ActualObjective.ObjectiveId);
      this.$emit("TaskSavedToObjective");
    },
    onEvidenceClose(val) {
      this.isEvidenceDialogVisible = val;
      this.$emit("OnTasksDialogClose", val);
    }
  }
};
</script>

<style scoped>
::v-deep .el-dialog__header {
  background-color: lightblue; /* Color de fondo morado */
  color: Black; /* Color del texto */
  font-weight: bold;
}

/* .movingToLeft {
  position: absolute;
  right: 1rem;
} */

.movingColToEnd {
  display: flex;
  justify-content: end;
}
</style>
